import { BaseModel } from "sjs-base-model";

export default class CqsOnlineRichiestaInfoSezionePreventivoViewModel extends BaseModel {
    public readonly id: number = 0;
    public readonly fkIdPreventivo: number = 0;
    public readonly fkIdGruppoDoc: number = 0;
    public readonly urlFirma: string = "";
    public readonly dtAttivazioneFirma: string = "";
    public readonly dtFirma: string = "";
    public readonly codiceMacroPratica: string = "";
    public readonly numeroMacroPratica: number = 0;
    public readonly dtCaricamento: string = "";
    public readonly stato: string = "";

    constructor(data: Partial<CqsOnlineRichiestaInfoSezionePreventivoViewModel>) {
        super();

        this.update(data);
    }
}
